module.exports = __webpack_public_path__ + "img/sinBarreras24.9e80bf19.jpg";